import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export const CampaignCardImage = ({ campaign: c, index, reverse }) => (
  <Link
    to={`/case/${c.slug}`}
    data-testid={`campaign-image-link-${index}`}
    className={`col-span-12 md:col-span-7 ${
      reverse ? "md:order-2" : ""
    } reveal block`}
  >
    <div className="relative overflow-hidden aspect-[4/3] md:aspect-[4/3] hairline border bg-[var(--ink)]">
      <img
        src={c.image}
        alt={c.title}
        data-testid={`campaign-image-${index}`}
        className="w-full h-full object-cover transition-all duration-[1200ms] ease-[cubic-bezier(0.16,1,0.3,1)] grayscale group-hover:grayscale-0 scale-[1.02] group-hover:scale-100"
        loading="lazy"
      />
      <div className="pointer-events-none absolute top-3 left-3 right-3 flex items-center justify-between text-[10px] tracking-[0.22em] uppercase text-white/85 mix-blend-difference">
        <span>Case №{String(index + 1).padStart(2, "0")}</span>
        <span>{c.year}</span>
      </div>
      <div className="pointer-events-none absolute bottom-3 right-3 inline-flex items-center gap-1.5 bg-[var(--paper)] text-[var(--ink)] px-3 py-1.5 text-[10px] tracking-[0.22em] uppercase font-medium opacity-0 group-hover:opacity-100 transition-opacity duration-500">
        Read case
        <ArrowUpRight className="w-3 h-3" strokeWidth={1.75} />
      </div>
    </div>
  </Link>
);
